import _ from 'lodash'
import { Box, Divider, Typography } from '@mui/material'
import { useOrgContext } from '~/common/context/organization/org-context'
import { TaskVelocityChart } from './task-velocity-chart'
import { CropPhaseChart } from './crop-phase-chart'
import { NumericTotals } from './numeric-totals'

export const OrgMetricsPanel = () => {
  const { activeOrgs } = useOrgContext()
  const activeOrg = _.last(activeOrgs)
  const orgName = activeOrg?.name

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', px: 1, py: 0.5 }}>
      {/* Section title — same format as climate panel */}
      <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0, mb: 0.25 }}>
        {activeOrg ? (
          <Typography
            variant="caption"
            sx={{
              fontWeight: 600,
              fontSize: '0.65rem',
              letterSpacing: '0.05em'
            }}
          >
            <Box
              component="span"
              sx={{
                fontSize: '0.75rem',
                fontWeight: 700,
                color: ({ palette }) => palette.mode === 'dark' ? 'primary.light' : 'primary.main'
              }}
            >
              {orgName}
            </Box>
            <Box component="span" sx={{ color: 'text.secondary' }}>
              {' '}
              METRICS
            </Box>
          </Typography>
        ) : (
          <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, fontSize: '0.65rem', letterSpacing: '0.05em' }}>
            METRICS
          </Typography>
        )}
      </Box>

      {/* Three sub-panels: task velocity | crop phase + yield */}
      <Box sx={{ flex: 1, minHeight: 0, display: 'flex', gap: 1 }}>
        {/* Task velocity — widest */}
        <Box sx={{ flex: '3 1 0', minWidth: 0 }}>
          <TaskVelocityChart />
        </Box>

        <Divider orientation="vertical" flexItem sx={{ my: 0.5, borderRightWidth: '2px' }} />

        {/* Crop phase + yield: stacked at md–lg, side by side at lg+ */}
        <Box sx={{ flex: '3 1 0', minWidth: 0, display: 'flex', flexDirection: { md: 'column', lg: 'row' }, gap: 1 }}>
          <Box sx={{ flex: '2 1 0', minHeight: 0, minWidth: 0 }}>
            <CropPhaseChart />
          </Box>

          <Divider sx={{ display: { md: 'block', lg: 'none' } }} />
          <Divider orientation="vertical" flexItem sx={{ display: { md: 'none', lg: 'flex' }, borderRightWidth: '2px', my: 0.5 }} />

          <Box sx={{ minHeight: 0, minWidth: 0 }}>
            <NumericTotals />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
